import '../style.css';

const CanceledSession = ()=>{
    return (
        <div className='container'>
            <div className='response-overlay'>
            <div className='response-box'>
            <div className='error-response'>
            <p>Verification Error</p>
    <div className='description'>
    It seems you declined the terms and conditions. <br/>
    If this was a mistake, please reach out to your Hiring Manager for assistance.
    </div>
    </div>
            </div>
            </div>
    </div>

    )
    
};

export default CanceledSession;